export const GET_BILLS_REQUEST = "GET_BILLS_REQUEST";
export const GET_BILLS_SUCCESS = "GET_BILLS_SUCCESS";
export const GET_BILLS_FAILURE = "GET_BILLS_FAILURE";
